import { render, staticRenderFns } from "./EducationDetailsHero.vue?vue&type=template&id=5313a136&scoped=true"
import script from "./EducationDetailsHero.vue?vue&type=script&lang=js"
export * from "./EducationDetailsHero.vue?vue&type=script&lang=js"
import style0 from "./EducationDetailsHero.vue?vue&type=style&index=0&id=5313a136&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5313a136",
  null
  
)

export default component.exports